import { render, staticRenderFns } from "./EmployeeLink.vue?vue&type=template&id=5410938c&scoped=true&"
import script from "./EmployeeLink.vue?vue&type=script&lang=js&"
export * from "./EmployeeLink.vue?vue&type=script&lang=js&"
import style0 from "./EmployeeLink.vue?vue&type=style&index=0&id=5410938c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5410938c",
  null
  
)

export default component.exports